import MyTerminal from 'makiru-terminal'
import staticList from './commands/static'
import dynamicList from './commands/dynamic'

const cmd = {
  dynamicList,
  staticList
}

const config = {
  prompt: '➜  ~ ',
  version: '1.0.0',
  initialDirectory: 'makiru の 简介',
  bootCmd: 'intro'
}

function App() {
   return <MyTerminal cmd={cmd} config={config} />
}

export default App;
